import { render, staticRenderFns } from "./PublicProductsForm.vue?vue&type=template&id=1f60ff3e&"
import script from "./PublicProductsForm.vue?vue&type=script&lang=js&"
export * from "./PublicProductsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PublicProductPriceSelect: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/inputs/PublicProductPriceSelect.vue').default,SpinButton: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/inputs/SpinButton.vue').default,RegistrationBeforeOrderModal: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/modals/RegistrationBeforeOrderModal.vue').default})
